import { render, staticRenderFns } from "./HomeAdminMember.vue?vue&type=template&id=2d8ce09a&scoped=true"
import script from "./HomeAdminMember.vue?vue&type=script&lang=js"
export * from "./HomeAdminMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ce09a",
  null
  
)

export default component.exports